import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { tokens } from '../../theme';

// Titled white panel used for every block of content in the portal.
export const Section = ({ title, action, children, sx }) => (
    <Paper variant="outlined" sx={{ overflow: 'hidden', ...sx }}>
        {title && (
            <Box
                sx={{
                    px: 2.5,
                    py: 1.5,
                    borderBottom: `1px solid ${tokens.line}`,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                }}
            >
                <Typography variant="h6" component="h2" sx={{ flex: 1 }}>
                    {title}
                </Typography>
                {action}
            </Box>
        )}
        <Box sx={{ p: 2.5 }}>{children}</Box>
    </Paper>
);

// Label above value, used in detail views.
export const Field = ({ label, value, mono }) => (
    <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" color="text.secondary">
            {label}
        </Typography>
        <Typography
            sx={{
                fontWeight: 500,
                mt: 0.25,
                wordBreak: 'break-word',
                fontVariantNumeric: mono ? 'tabular-nums' : 'normal',
                letterSpacing: mono ? 0.3 : 'normal',
            }}
        >
            {value || '—'}
        </Typography>
    </Box>
);

export const FieldGrid = ({ children, columns = 2 }) => (
    <Box sx={{ display: 'grid', gap: 2.5, gridTemplateColumns: { xs: '1fr', sm: `repeat(${columns}, minmax(0, 1fr))` } }}>
        {children}
    </Box>
);
